module.exports = __webpack_public_path__ + "img/wechat.df6e92e9.png";